module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n4r6n9n-b348476b83a25be56b4ebe4f808e07a1.svg";